import React, {Component} from 'react';
import {connect} from 'react-redux';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {Modal, Button, TextArea, Grid, Icon, Input} from 'semantic-ui-react';
import {dateFormatPicker, noTimeZoneShortISODate} from '../../../../common/constants/datesFormat';
import {Actions} from '../../../../common/actions';
import './editModal.scss';

class ModalEditProviderImportation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalWasOpen': false,
      'dateFilter': '',
      'observation': '',
    };
    this.onCloseModalClick = this.onCloseModalClick.bind(this);
    this.onSaveClick = this.onSaveClick.bind(this);
    this.changeStartDate = this.changeStartDate.bind(this);
    this.onChangeObservationText = this.onChangeObservationText.bind(this);
  }

  fetchData() {
    const {defaultDate} = this.props;
    const formattedDefaultDate = defaultDate ?
      moment(defaultDate).format(noTimeZoneShortISODate) :
      '';

    this.setState({
      'modalWasOpen': true,
      'dateFilter': formattedDefaultDate,
      'observation': '',
    });
  }

  changeStartDate(date) {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);
    this.setState({'dateFilter': dateFormatted});
  }

  onChangeObservationText(event) {
    const value = event.target.value;
    this.setState({'observation': value});
  }

  onCloseModalClick() {
    this.setState({'modalWasOpen': false});
  }

  onSaveClick() {
    const {dateFilter, observation} = this.state;
    const {invoice, position} = this.props;
    if (!(dateFilter && observation && observation.length >= 5)) {
      return;
    }
    const data = {
      'po': invoice,
      'date': dateFilter,
      observation,
    };
    const payload = {
      'etaUpdated': dateFilter,
      invoice,
      observation,
      position,
    };
    this.props.updateProviderImportations(data, payload);
    this.onCloseModalClick();
  }

  render() {
    const {modalWasOpen, dateFilter, observation} = this.state;
    const {invoice} = this.props;

    return (
      <Modal
        size='small'
        onOpen={() => this.fetchData()}
        className='modal-edit-importations'
        open={modalWasOpen}
        trigger={<Icon name='write' color='blue' size='large' />}
      >
        <Modal.Header>Cambio ETA - Embarque {invoice}</Modal.Header>

        <Modal.Content>
          <Modal.Description>
            <Grid>
              <Grid.Row>
                <Grid.Column>
                  <div>
                    <strong>Nuevo ETA</strong>
                  </div>
                  <DatePicker
                    customInput={<Input icon='calendar' size='small' />}
                    dateFormat={dateFormatPicker}
                    selected={
                      dateFilter ?
                        moment(dateFilter, noTimeZoneShortISODate).toDate() :
                        null
                    }
                    onChange={this.changeStartDate}
                    locale='es'
                    placeholderText='Fecha'
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <div>
                    <strong>Observaciones</strong>
                  </div>
                  <TextArea
                    rows={10}
                    value={observation}
                    onChange={this.onChangeObservationText}
                    maxLength='40'
                    required
                    autoComplete='off'
                    placeholder='Observaciones'
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={this.onCloseModalClick}>Cancelar</Button>
          <Button
            primary
            onClick={this.onSaveClick}
            disabled={!(dateFilter && observation && observation.length >= 5)}
          >
            Guardar
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const {
  updateProviderImportations,
} = Actions;

export default connect(null, {
  updateProviderImportations,
})(ModalEditProviderImportation);
